module.exports = __webpack_public_path__ + "static/media/mobility-of-modernism-harper-montgomery.7fdcf806.jpg";